module.exports = "<footer class=\"footer\">\r\n  <div class=\"container\">\r\n    <ul class=\"footer-list\">\r\n      <li><a title=\"Coming Soon\" [routerLink]=\"['/privacy-conditions']\">Privacy </a></li>\r\n      <li><a title=\"Coming Soon\" [routerLink]=\"['/terms-conditions']\"> Terms of Use </a></li>\r\n      <li><a title=\"Coming Soon\">Cookies </a> </li>\r\n      <li><a title=\"Coming Soon\">Advertising </a> </li>\r\n    </ul>\r\n    <p class=\"copyright\">Bidjones © 2018</p>\r\n  </div>\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main